import {ZIDX, ZIDXPage} from "../../../standalone/standaloneLibrary.js";

export class ZIDXAccountSavedSearches implements ZIDXPage{
    zidx:ZIDX;
    constructor(zidx:ZIDX) {
        this.zidx = zidx;
    }
    getPageClass(){
        return "zidxAccountSavedSearchesContainer";
    }
    render(){
        // console.log("saved searches");
    }
}